import { render, staticRenderFns } from "./OrdersTrack.vue?vue&type=template&id=a605fa78&"
import script from "./OrdersTrack.vue?vue&type=script&lang=js&"
export * from "./OrdersTrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports